import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {WeightGrid} from '../message/WeightGrid';
import {WeightGridCriteria} from './WeightGridCriteria';
import {WeightGridScenario} from './WeightGridScenario';

export class WeightGridWrapper extends BaseWrapper<WeightGrid, WeightGridCriteria, WeightGridScenario>  {}

